import React from 'react';
import { motion } from 'framer-motion';

const ServiceCard = ({ icon, title, description, items }) => {
  const cardAnimation = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: [0, 0.71, 0.2, 1.01]
      }
    },
    hover: {
      scale: 1.02,
      boxShadow: "0px 5px 20px rgba(0,0,0,0.15)",
      transition: {
        duration: 0.2
      }
    }
  };

  return (
    <motion.div 
      className="bg-gray-800 rounded-xl p-6 shadow-lg hover:bg-gray-750 transition-colors duration-300 h-full border border-gray-700"
      variants={cardAnimation}
      initial="hidden"
      animate="visible"
      whileHover="hover"
    >
      <div className="text-3xl text-blue-500 mb-4">
        {icon}
      </div>
      <h3 className="text-xl font-semibold text-white mb-3">{title}</h3>
      <p className="text-gray-400 mb-4">{description}</p>
      <ul className="space-y-2">
        {items.map((item, index) => (
          <li key={index} className="flex items-start">
            <span className="text-green-500 mr-2">✓</span>
            <span className="text-gray-300">{item}</span>
          </li>
        ))}
      </ul>
    </motion.div>
  );
};

export default ServiceCard;
